export default "__VITE_ASSET__CWOZVsgF__"